import { on } from "delegated-events";
import qs from "qs";
import { generateUrl } from "@common/util";

const fn = {
    init: () => {

        fn.crtapp = document.getElementById("crtapp-root");

        fn.form = fn.crtapp.querySelector(".filter-form");
        fn.searchForm = fn.crtapp.querySelector(".site-menu-form");

        on("click", ".site-menu-search", fn.handleSiteMenuSearch);
        on("submit", ".site-menu-form", fn.handleSiteMenuSearch);
        on("click", ".mobile-site-menu-search", fn.handleMobileSiteMenuSearch);
        on("click", ".sidebar-filter", fn.handleQuerySubmission);
        on("change", ".sidebar-filter", fn.handleQuerySubmission);
        on("change", 'input[type="checkbox"]', fn.handleCheckboxUpdate);
        on("click", ".mobile-checkboxes", fn.handleMobileCheckboxUpdate);
        on("click", ".category-list-submit", fn.handleCategorySubmission);
        on("click", ".modal-filters-search", fn.handleModalFiltersSearch);
        on("change", "[data-select]", fn.handleSelectOptions);
        on("submit", ".filter-form", fn.handleFilterFormSubmit);
    },

    handleSiteMenuSearch: (e) => {
        e.preventDefault();

        const keywordInput = fn.crtapp.querySelector(".combined-search-input");
        const serviceInput = fn.crtapp.querySelector(".combined-search-values");
        const countyInput = fn.crtapp.querySelector(".search-county");

        const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        const serviceValue = serviceInput ? serviceInput.value : '';
        currentParams.county = countyInput ? countyInput.value : '';
        currentParams.page = 'search';

        if (serviceValue) {
            delete currentParams.keyword;

            const values = serviceValue.split(',').filter(Boolean);
            const main = values.filter((value) => value.startsWith('main-'));
            const sub = values.filter((value) => value.startsWith('sub-'));
            const third = values.filter((value) => value.startsWith('third-'));

            if (main.length || third.length) {
                currentParams.service = [...main, ...third].join(',');
            } else {
                delete currentParams.service;
            }
            if (sub.length) {
                currentParams.subcategory = sub.join(',');
            } else {
                delete currentParams.subcategory;
            }
            delete currentParams.thirdCategory;
        } else {
            delete currentParams.service;
            delete currentParams.subcategory;
            delete currentParams.thirdCategory;
            currentParams.keyword = keywordInput ? keywordInput.value : '';
        }

        // Remove stale params from the URL
        delete currentParams.practice;
        delete currentParams.practiceID;
        delete currentParams.relatedCategories;

        const url = generateUrl(fn.searchForm, currentParams, true);

        window.location.href = url;
    },

    handleMobileSiteMenuSearch: (e) => {
        e.preventDefault();

        const searchInputValueMobile = fn.crtapp.querySelector(".mobileSearch").value;

        const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        currentParams.service =  searchInputValueMobile;
        currentParams.page = 'search';

        // Remove related categories from the URL
        delete currentParams.relatedCategories;
        delete currentParams.practiceID;

        const url = generateUrl(fn.searchForm, currentParams, true);

        window.location.href = url;
    },

    handleQuerySubmission: (e) => {
        let selectedQuery = e.currentTarget.value;
        const queryName = e.currentTarget.name;

        let currentParams = {};
        let url = {};
        if (e.target.classList.contains("practice-checkbox")) {
            console.log('practice checkboxes')
            let targetId = e.target.id;

            // targetId  may be in the form of list-main-$ID, list-sub-$ID, list-third-$ID
            // if it is list-sub, i need to set the urlparam subcategory, otherwise set it to service
            if (targetId.startsWith("list-sub")) {
                currentParams.subcategory = selectedQuery;
            }
            else if (targetId.startsWith("list-main")) {
                currentParams.service = selectedQuery;
            }
            else if (targetId.startsWith("list-third")) {
                currentParams.thirdCategory = selectedQuery;
            }

            const fullUrl = new URL(window.location.href);
            const viewParam = fullUrl.searchParams.get("view");
            const baseUrl = new URL(fullUrl.origin + fullUrl.pathname);
            if (viewParam) {
                baseUrl.searchParams.set("view", viewParam);
            }
            if (currentParams.subcategory) {
                baseUrl.searchParams.set("subcategory", currentParams.subcategory);
            }
            if (currentParams.service) {
                baseUrl.searchParams.set("service", currentParams.service);
            }
            if (currentParams.thirdCategory) {
                baseUrl.searchParams.set("thirdCategory", currentParams.thirdCategory);
            }
            baseUrl.searchParams.set("page", "search");
            url = baseUrl.href;
        }
        else {
            currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
            currentParams[queryName] = selectedQuery;
            delete currentParams.practiceID;
            url = generateUrl(fn.form, currentParams, selectedQuery, queryName);
        }

        console.log(url);

        window.location.href = url;
    },

    handleCheckboxUpdate: (e) => {
        const checkbox = e.currentTarget;

        if (checkbox.checked) {
            checkbox.classList.add("checked");
        } else {
            checkbox.classList.remove("checked");
        }
    },

    handleMobileCheckboxUpdate: (e) => {
        e.preventDefault();

        const checkboxLabel = e.currentTarget;
        const forValue = checkboxLabel.getAttribute("for");
        const checkbox = document.getElementById(forValue);
        const relatedCategoriesContainer = document.querySelector(`[data-related-category="${forValue}"]`);

        checkbox.classList.toggle("checked");

        // Handle related categories active state
        if (relatedCategoriesContainer) {
            if (checkbox.classList.contains("checked")) {
                relatedCategoriesContainer.classList.add("pill-fill-active");
            } else {
                relatedCategoriesContainer.classList.remove("pill-fill-active");
            }
        }
    },

    handleCategorySubmission: (e) => {
        e.preventDefault();

        const categoryListForm = document.querySelector(".category-list-form");
        const checkboxes = categoryListForm.querySelectorAll('input[type="checkbox"].checked');

        const params = Array.from(checkboxes).reduce((acc, checkbox) => {
            if (!acc[checkbox.name]) {
                acc[checkbox.name] = [];
            }
            acc[checkbox.name].push(checkbox.value);
            return acc;
        }, {});

        if (params.service) {
            params.service = params.service.join(",");
        }

        // Get zip code value if present
        const zipCodeInput = categoryListForm.querySelector('#zip');
        const zipCodeValue = zipCodeInput ? zipCodeInput.value.trim() : '';

        // Get radius value if present
        const radiusInput = categoryListForm.querySelector('#radius');
        const radiusValue = radiusInput ? radiusInput.value : '';

        // Get practice value if present
        const practiceInput = categoryListForm.querySelector('#practice');
        const practiceValue = practiceInput ? practiceInput.value.trim() : '';

        const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        currentParams.service = params.service;
        currentParams.subcategory = params.subcategory;
        currentParams.page = 'search';
        delete currentParams.practiceID;

        if (zipCodeValue) {
            currentParams['zip'] = zipCodeValue;
        } else {
            delete currentParams['zip'];
        }

        if (radiusValue) {
            currentParams['radius'] = radiusValue;
        } else {
            delete currentParams['radius'];
        }

        if (practiceValue) {
            currentParams['practice'] = practiceValue;
        } else {
            delete currentParams['practice'];
        }

        const url = generateUrl(categoryListForm, currentParams);

        window.location.href = url;
    },

    handleModalFiltersSearch: (e) => {
        e.preventDefault();

        const modalFiltersForm = document.querySelector(".modal-filters-form");
        const checkboxes = modalFiltersForm.querySelectorAll('input[type="checkbox"].checked');
        const selectedSort = modalFiltersForm.querySelector('select option:checked');

        const params = Array.from(checkboxes).reduce((acc, checkbox) => {
            if (!acc[checkbox.name]) {
                acc[checkbox.name] = [];
            }
            acc[checkbox.name].push(checkbox.value);
            return acc;
        }, {});

        const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        currentParams.page = 'search'
        delete currentParams.practiceID;

        if (params.sort) {
            currentParams.sort = selectedSort.value;
        } else {
            currentParams.sort = selectedSort.value;
        }

        if (params.relatedCategories) {
            params.relatedCategories = params.relatedCategories.join(",");
            currentParams.relatedCategories = params.relatedCategories;
        } else {
            currentParams.relatedCategories = "";
        }

        if (params.accessibility) {
            params.accessibility = params.accessibility.join(",");
            currentParams.accessibility = params.accessibility;
        } else {
            currentParams.accessibility = "";
        }

        if (params.insurance) {
            params.insurance = params.insurance.join(",");
            currentParams.insurance = params.insurance;
        } else {
            currentParams.insurance = "";
        }

        if (params.practiceAttr) {
            params.practiceAttr = params.practiceAttr.join(",");
            currentParams.practiceAttr = params.practiceAttr;
        } else {
            currentParams.practiceAttr = "";
        }

        if (params.ageGroups) {
            params.ageGroups = params.ageGroups.join(",");
            currentParams.ageGroups = params.ageGroups;
        } else {
            currentParams.ageGroups = "";
        }

        if (params.disabilitySpecializations) {
            params.disabilitySpecializations = params.disabilitySpecializations.join(",");
            currentParams.disabilitySpecializations = params.disabilitySpecializations;
        } else {
            currentParams.disabilitySpecializations = "";
        }

        if (params.culturalGroups) {
            params.culturalGroups = params.culturalGroups.join(",");
            currentParams.culturalGroups = params.culturalGroups;
        } else {
            currentParams.culturalGroups = "";
        }

        const url = generateUrl(modalFiltersForm, currentParams);

        window.location.href = url;
    },

    handleFilterFormSubmit: (e) => {
        const form = e.currentTarget;

        // Pagination form carries hidden fields and submits natively via GET
        if (form.classList.contains('dropdown-pagination')) {
            return;
        }

        e.preventDefault();

        const fieldNames = Array.from(form.querySelectorAll('input[name], select[name]'))
            .map((field) => field.name)
            .filter((name, index, self) => self.indexOf(name) === index);

        const selected = {};
        form.querySelectorAll('input[type="checkbox"]:checked').forEach((checkbox) => {
            if (!checkbox.name) return;
            if (!selected[checkbox.name]) selected[checkbox.name] = [];
            selected[checkbox.name].push(checkbox.value);
        });
        form.querySelectorAll('select[name]').forEach((select) => {
            if (select.value) selected[select.name] = [select.value];
        });

        const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        delete currentParams.practiceID;

        // Drop form-owned params that are no longer selected
        fieldNames.forEach((name) => {
            if (!selected[name] || selected[name].length === 0) {
                delete currentParams[name];
            }
        });

        Object.keys(selected).forEach((name) => {
            const values = selected[name];
            if (name === 'service' && values.some((value) => /^(main|sub|third)-/.test(value))) {
                const main = values.filter((value) => value.startsWith('main-'));
                const sub = values.filter((value) => value.startsWith('sub-'));
                const third = values.filter((value) => value.startsWith('third-'));
                if (main.length || third.length) {
                    currentParams.service = [...main, ...third].join(',');
                } else {
                    delete currentParams.service;
                }
                if (sub.length) {
                    currentParams.subcategory = sub.join(',');
                } else {
                    delete currentParams.subcategory;
                }
                delete currentParams.thirdCategory;
            } else {
                currentParams[name] = values.join(',');
            }
        });

        currentParams.page = 'search';

        const url = generateUrl(form, currentParams, true);
        window.location.href = url;
    },

    handleSelectOptions: (e) => {
        let selectedQuery = e.currentTarget.value;
        const queryName = e.currentTarget.name;

        const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        currentParams[queryName] = selectedQuery;
        currentParams.page = 'search'
        delete currentParams.practiceID;

        const url = generateUrl(fn.form, currentParams, true);

        window.location.href = url;
    },
};

export default {
    can: () => document.querySelector("form"),
    run: fn.init,
};
